export const LOADING_ICON_SIZE = 90;
